module.exports = __webpack_public_path__ + "assets/images/2f879b898621d92f81ba3d9975b30adb.png";